import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';
import { Route } from '@app/core';

const routes: Routes = [
  {
    path: 'system',
    loadChildren: () => import('./system/system.module').then(m => m.SystemModule)
  },
  {
    path: 'mydevice-config/:id',
    loadChildren: () => import('./mydevice-config/mydevice-config.module').then(m => m.MyDeviceConfigModule)
  },{
    path: 'alarm-management',
    loadChildren: () => import('./alarm-management/alarm-management.module').then(m => m.AlarmManagementModule)
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: []
})
export class AppRoutingModule { }
